export const OPTION_REQUEST = 'OPTION_REQUEST'
export const OPTION_ERROR = 'OPTION_ERROR'
export const OPTION_GET = 'OPTION_GET'
export const OPTION_GET_SUCCESS = 'OPTION_GET_SUCCESS'
